import React from 'react';
import { Tag } from 'antd';
import PropTypes from 'prop-types';
import styles from './status-tag.module.scss';

/**
 * StatusTag
 *
 * Displays a colored tag based on the provided status.
 *
 * @param {Object} props - Component properties
 * @param {string} props.status - Status value to display and determine tag color
 */
export const StatusTag = ({ status }) => {
  const statusColors = {
    new: { color: '#1d4ed8', background: '#eff6ff' },
    attempting: { color: '#a16207', background: '#fefce8' },
    working: { color: '#7e22ce', background: '#faf5ff' },
    'application-sent': { color: '#0f9d58', background: '#e8f5e9' },
    'application-received': { color: '#db4437', background: '#ffebee' },
  };

  const style = statusColors[status] || { color: '#44464B', background: '#f1f3f4' };

  return (
    <Tag
      className={styles.statusTag}
      style={{
        color: style.color,
        backgroundColor: style.background,
        border: `1px solid ${style.color}`,
        textTransform: 'capitalize',
      }}>
      {status}
    </Tag>
  );
};

StatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};
